<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import JSEncrypt from 'jsencrypt'
// import JSEncrypt from "jsencrypt/bin/jsencrypt.min.js";
import { key } from "@/axios/request/request";
export default {
  name: "App",
  provide() {
    return {
      baseUrl: process.env.NODE_ENV == "development" ? "" : window.dynUrl.url, //广东专用 http://gdjyj.gd.gov.cn
    };
  },
  data() {
    return {
      isRouterAlive: true,
      clientHeight: "",
    };
  },
  methods: {},
  created() {
    return false;
    let PUBLIC_KEY =
      "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApavQNrSrGY4kz6t5I9qpDewThE9Wc/f5egurXMFUW49AQxESONVueT91F/P0USti6uh1I8a+R3ptEaqXzOsliWd19RPK2igo9mUiRNxXwhY6GlSSBEFb3EUiWHRqMXJ+f00qxRVtBrgVBXvPWjuIm7WmNIaj514gqo4VVXmFR/ILKHUGLnrBJgeJvbJ1uEnwJOnHrgOuRhC1OAklJlOmejcPm0w1QyUL2A3/De8nQzpd/EPJ0QEtBoO7BdDPfJbysGD0aPBFz/fGWI8sXUNRbW143EjLKZeQmW5yoXCdc3JYhB38kvR7eZJ4XvwX3l73jK+edYlchKwcEqanF5N8FwIDAQAB";
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(
      "-----BEGIN PUBLIC KEY-----" + PUBLIC_KEY + "-----END PUBLIC KEY-----"
    );
    let times = new Date().getTime();
    var encrypted = encrypt.encrypt(
      '{"key":"","timestamp":"' + times + '"}'
    );
    let data = {
      queryName: "token",
      data: {
        appID: "13566201069",
        timestamp: times,
        sign: encrypted,
      },
    };
    // key(data).then(res=>{
    //     this.$store.commit('SET_TOKEN',res.response.data.token.token);
    // })
  },
  mounted() {
    // window.onkeydown =
    //   window.onkeyup =
    //   window.onkeypress =
    //     function (event) {
    //       // 判断是否按下F12，F12键码为123
    //       if (event.keyCode === 123) {
    //         event.preventDefault(); // 阻止默认事件行为
    //         window.event.returnValue = false;
    //       }
    //     };
    // // 为右键添加自定义事件，可以禁用
    // window.oncontextmenu = function () {
    //   event.preventDefault(); // 阻止默认事件行为
    //   return false;
    // };
    // var threshold = 160; // 打开控制台的宽或高阈值
    // // 每秒检查一次
    // setInterval(function () {
    //   if (
    //     window.outerWidth - window.innerWidth > threshold ||
    //     window.outerHeight - window.innerHeight > threshold
    //   ) {
    //     // 如果打开控制台，则关闭控制台
    //     window.close();
    //     window.location = "about:blank";
    //   }
    // }, 1e3);
  },
  watch: {},
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  padding: 0;
  margin: 0;
  height: 100%;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue